import {Stack, Typography} from '@mui/material';
import React from 'react';
import {ScrollToTop} from 'presentation/components';
import {BookingErrorState} from 'presentation/modules/booking/shared/ui/components/BookingErrorState';
import {BookingLoadingState} from 'presentation/modules/booking/shared/ui/components/BookingLoadingState';
import {translations} from 'presentation/translations-new';
import {ExamUnitsAccreditedNetwork} from './components/ExamUnitsAccreditedNetwork';
import {ExamUnitsSelfNetwork} from './components/ExamUnitsSelfNetwork';
import {ExamUnitsNotFoundState} from './components/ExamUnitsNotFoundState';
import {useExamUnits} from './hooks/useExamUnits';
import {ExamUnitsProps} from './types';
import {ExamAdvanceUnits} from './components/ExamAdvanceUnits';

const {loadingError, loadingState} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;
const {bookExams} = translations['pt-br'].privateFlow.services;
const {resultFound} = translations['pt-br'].commons;

export function ExamUnits({handleNextStep}: ExamUnitsProps) {
	const {
		isLoading,
		isError,
		refetch,
		showNotFoundState,
		unitsList,
		showResultFoundTitle,
		showAccreditedNetwork,
		showSelfNetwork,
		shouldReverseNetworkOrder,
		advanceUnits,
		showAdvanceUnits,
		hideAdvanceUnitsDivider,
	} = useExamUnits();

	if (isLoading) {
		return (
			<BookingLoadingState
				showHeader={false}
				pageTitle={bookExams}
				loadingText={loadingState}
				variant="skeleton"
			/>
		);
	}

	if (isError) {
		return (
			<BookingErrorState
				showHeader={false}
				pageTitle={bookExams}
				errorTitle={loadingError}
				handleRefresh={refetch}
			/>
		);
	}

	if (showNotFoundState) {
		return <ExamUnitsNotFoundState />;
	}

	return (
		<Stack gap={2}>
			{showResultFoundTitle ? (
				<Typography variant="subtitle2" color="text.secondary" sx={{mb: -1}}>
					{resultFound}
				</Typography>
			) : null}

			{showAdvanceUnits ? (
				<ExamAdvanceUnits
					advanceUnits={advanceUnits}
					handleNextStep={handleNextStep}
					hideDivider={hideAdvanceUnitsDivider}
				/>
			) : null}

			<Stack gap={2} flexDirection={shouldReverseNetworkOrder ? 'column-reverse' : 'column'}>
				{showSelfNetwork() ? (
					<ExamUnitsSelfNetwork handleNextStep={handleNextStep} unitsList={unitsList} />
				) : null}

				{showAccreditedNetwork() ? (
					<ExamUnitsAccreditedNetwork unitsList={unitsList} />
				) : null}
			</Stack>

			<ScrollToTop />
		</Stack>
	);
}
